document.createElement( "picture" );

(function ($){
  $(window).load(function() {
    $('.flexslider').each(function () {
      var options = $(this).data('options');
      var defaultOptions = {
        animation: "slide"
      };
      options = $.extend({}, defaultOptions, options);
      $(this).flexslider(options);
    });
    /**
     * Product single tab
     */
    var tabLinks = $('.tab-link').not('.download');
    if(tabLinks.length > 0){
      tabLinks.on('click', function (e) {
        e.preventDefault();
        var $this = $(e.currentTarget);
        $('.tab-link').removeClass('active');
        $('.tab-content').removeClass('active');
        $this.addClass('active');
        var id =  $this.data('tab');
        var tab = $(id);
        if(tab.length > 0){
          tab.addClass('active')
        }
      });
      tabLinks.eq(0).trigger('click');
    };

    var collapseLinks = $('.collapse-trigger');
    if(collapseLinks.length > 0){
      collapseLinks.on('click', function (e) {
        e.preventDefault();
        var $this = $(e.currentTarget);
        $('.collapse-trigger').removeClass('active');
        $('.collapse-content').removeClass('active');
        $this.addClass('active');
        var id =  $this.data('target');
        var tab = $(id);
        if(tab.length > 0){
          tab.addClass('active')
        }
      });
      collapseLinks.eq(0).trigger('click');
    };
    // Mobile trigger
    var $mobileTrigger = $('#main-navigation-trigger');
    if($mobileTrigger.length > 0){
      $mobileTrigger.on('click', function () {
        $('.main-navigation').toggleClass('active');
      });
    }
    // Submenu trigger
    var $mobileSubmenuTrigger = $('.submenu-trigger');
    if($mobileSubmenuTrigger.length > 0){
      $mobileSubmenuTrigger.on('click', function (e) {
        var $currentLi = $(this).parent().parent();
        $currentLi.find('.sub-menu').toggleClass('active');
        $currentLi.toggleClass('active');
      });
    }
    // Grid
    var $marketBlocks = $('.market-grid .market-item');
    var $background = $('.market-grid .background');
    var $marketGridLink = $('.market-grid .grid-link');
    var $marketResizer = $('.market-grid .resizer-row #resizer');
    $(document).on('resize', function () {
      var resizerWidth = $marketResizer.width();
      var gridLinkWidth = $marketGridLink.width() - resizerWidth;
      var backgroundHeigth = gridLinkWidth / 1.6;
      $background.height(backgroundHeigth);
      $marketGridLink.css('padding-left', resizerWidth + 'px');
      $marketBlocks.width($background.width() - resizerWidth);
    });
    $(document).trigger('resize');

      // Search AutoComplete by
      // Awesomplete: http://leaverou.github.io/awesomplete/
      // And save data with localStorage: https://github.com/pamelafox/lscache
      var $awesomplete = new Awesomplete(document.getElementById("search-field"), {
          maxItems: 4,
          minChars: 1
      });
      $( "#search-field" ).on( "click", function() {
          // Remove for test
          //lscache.remove('searchData');

          var $searchData = lscache.get('searchData');
          if ($searchData) {
              $awesomplete.list = $searchData;
          }
          else {
              $.post(
                  ajaxurl,
                  {
                      action: "searchGetData"
                  },
                  function(response){
                      lscache.set('searchData', response, 10); // Set expired is 10 minutes
                      $awesomplete.list = response;
                  }
              );
          }
      });
      $("#search-field").on('awesomplete-selectcomplete',function(){
          window.location = this.value;
          this.value = '';
      });
  });

})(jQuery);
